__webpack_require__.p = "//static.hsappstatic.net/academy-public-ui/static-1.10790/";